window.Drupal.behaviors.app_table = {
  attach: (context, settings) => {
    try {
      const currentWidth = window.innerWidth;
      if (currentWidth <= 767) {
        $(".js-table").FixTablesAccessibility();
      }
    } catch (e) {}
  },
};
